/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["ponoć", "podne", "jutro", "po pod.", "veče", "noć"], ["ponoć", "podne", "jutro", "po pod.", "uveče", "noću"], ["ponoć", "podne", "ujutro", "po podne", "uveče", "noću"]], [["ponoć", "podne", "jutro", "popodne", "veče", "noć"], u, u], ["00:00", "12:00", ["06:00", "12:00"], ["12:00", "18:00"], ["18:00", "21:00"], ["21:00", "06:00"]]];
